/** External Dependencies */
import styled from "styled-components";
import Label from "@scaleflex/ui/core/label";

const StyledAppWrapper = styled.div.attrs(({ $size = {} }) => ({
  style: {
    width: $size.width ?? "100%",
    height: $size.height ?? "100%",
  },
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  max-height: 100%;
  width: 100%;
  max-width: 100%;
  overflow: auto;
  position: relative;
  min-height: 250px;
  min-width: 300px;
  background: ${({ theme }) => theme.palette["bg-secondary"]};
`;

const StyledMainContent = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  height: calc(100% - 95px); // 95px = possible max height of topbar w/ spaces
  flex-grow: 1;

  [data-phone="true"] & {
    padding: 0;
  }
`;

const StyledCanvasAndTools = styled.div`
  height: 100%;
  width: calc(100% - 80px); // 80px = tabsbar's width.
  flex-grow: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

const StyledPhoneToolsAndTabs = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const StyledLabelContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;
  padding: 0px 12px;
`;
const StyledBottomLabel = styled(Label)`
  font-size: 14px;
  color: #dc3545 !important;
  font-weight: 600;
  line-height: 15px;
  margin-bottom: 0px !important;
`;

export { StyledAppWrapper, StyledMainContent, StyledCanvasAndTools, StyledPhoneToolsAndTabs, StyledBottomLabel, StyledLabelContainer };
